import React, { useRef, useState } from "react";

import { Grid, Typography } from "@material-ui/core";

import { useTraslados } from "../../../hooks/useCases/useTraslados";
import { GAccordion } from "../../atomic/organisms/GAccordion";
import AlertCircle from "../../autorizaciones/UI/AlertCircle";
import CheckCircle from "../../autorizaciones/UI/CheckCircle";
import AutoCompleteDiagnostico from "../../autorizaciones/UI/AutoCompleteDiagnostico";
import LetterX from "../../autorizaciones/UI/LetterX";
import { GenericDocumentacion } from "../../atomic/organisms/GenericDocumentacion";

export const DocumentacionDiagnosticoTraslado = ({ formValues, setFormValues, disabled }) => {
    const componentRef = useRef();
    const { data, upload, remove } = useTraslados();

    const [autoCompleteValue] = useState(null);
    
    return (
        <Grid container spacing={2} style={{padding: "1em"}}>
            <Grid item xs={12}>
                <GAccordion 
                    title={(
                        <Typography variant="h6">
                            Diagnóstico
                            {!formValues.diagnostico 
                                ? <AlertCircle /> 
                                : <CheckCircle />
                            }
                        </Typography>
                    )}
                >
                    <Grid item xs={11}>
                        {!formValues.diagnostico ? (
                            <AutoCompleteDiagnostico
                                ref={componentRef}
                                autoCompleteValue={autoCompleteValue}
                                label="Diagnóstico"
                                onChangeHandler={(diagnostico) => setFormValues({...formValues, diagnostico, idDiagnostico: diagnostico.idProblema})}
                            />
                        ) : (
                            <Typography
                                style={{
                                color: "#68389F",
                                width: "-webkit-fill-available",
                                fontSize: "1rem",
                                fontWeight: "bold",
                                fontStyle: "italic",
                                postion: "relative",
                                }}
                            >
                                {formValues.diagnostico.problema}
                                {!disabled && (
                                    <LetterX 
                                        deleteFunction={() => setFormValues({...formValues, diagnostico: null})} 
                                        styles={{ position: "absolute", marginLeft: "0.5rem", cursor: "pointer" }}
                                    />
                                )}
                            </Typography>
                        )}
                        </Grid>
                </GAccordion>
            </Grid>
            <Grid item xs={12}>
                <GAccordion 
                    title={(
                        <Typography variant="h6">
                            Documentación
                            {data.tipoDocSolicitudes.some(item => item.obligatorio && formValues.documentacion.some(({idTipoDoc}) => idTipoDoc === item.idTipoDoc))
                                ? <CheckCircle />
                                : <AlertCircle /> 
                            }
                        </Typography>
                    )}
                >
                    <GenericDocumentacion
                        tiposDocumentacion={data.tipoDocSolicitudes.map(item => ({...item.tipoDocumentacion}))}
                        documentacion={formValues.documentacion.map(item => ({...item, idDocumentacion: item.id}))}
                        disabledAdd={(doc) => formValues.documentacion.some(x => x.idTipoDoc === doc.idTipoDoc)}
                        fieldsDisabled={disabled}
                        deleteDocumentacion={(id) => {
                            remove.documentacion(id, setFormValues, formValues)
                        }}
                        handleFile={(files, idTipDoc) => {
                            upload.documentacionSolicitudes(files, idTipDoc, formValues.id, setFormValues, formValues)
                        }}
                    />
                </GAccordion>
            </Grid>
        </Grid>
    );
};
